var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { titleTextStyle } from './title.linaria';
/**
 * A component used for titles. Remember to set the 'level' prop, always start from `<h1>`, followed by `<h2>` and so on.
 * You can read more about the h1-h6 elements [here](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements).
 */
function Title(_a) {
    var { className, children, size = 'xl', level = 'span' } = _a, props = __rest(_a, ["className", "children", "size", "level"]);
    // This gets the title with a specific 'level'. h1, h2 etc.
    const TitleText = level;
    return (<TitleText {...props} className={classNames([className, size, titleTextStyle])}>
      {children}
    </TitleText>);
}
Title.defaultProps = {
    className: null,
};
export default Title;
